var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaguesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53125 9.10434V13.6452C3.53125 15.308 3.53125 15.308 5.10273 16.3679L9.4243 18.8621C10.073 19.2367 11.1328 19.2367 11.7815 18.8621L16.1031 16.3679C17.6746 15.308 17.6746 15.308 17.6746 13.6452V9.10434C17.6746 7.4415 17.6746 7.4415 16.1031 6.38166L11.7815 3.88739C11.1328 3.5128 10.073 3.5128 9.4243 3.88739L5.10273 6.38166C3.53125 7.4415 3.53125 7.4415 3.53125 9.10434Z",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6283 6.00714V3.60423C15.6283 1.77693 14.7146 0.863281 12.8873 0.863281H8.31908C6.49178 0.863281 5.57812 1.77693 5.57812 3.60423V5.94318",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1767 9.07706L11.6974 9.89021C11.7797 10.0181 11.9624 10.146 12.0995 10.1826L13.0314 10.4201C13.607 10.5663 13.7623 11.0597 13.3877 11.5165L12.7756 12.2566C12.6842 12.3753 12.6111 12.5855 12.6202 12.7317L12.6751 13.691C12.7116 14.2849 12.2913 14.5864 11.7431 14.3671L10.8478 14.0108C10.7107 13.956 10.4823 13.956 10.3452 14.0108L9.44986 14.3671C8.90167 14.5864 8.48139 14.2757 8.51794 13.691L8.57276 12.7317C8.58189 12.5855 8.5088 12.3662 8.41744 12.2566L7.80529 11.5165C7.43069 11.0597 7.58602 10.5663 8.16162 10.4201L9.09354 10.1826C9.23972 10.146 9.42245 10.009 9.49555 9.89021L10.0163 9.07706C10.3452 8.58369 10.8569 8.58369 11.1767 9.07706Z",
    stroke: "#717C91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaguesIcon);
export default __webpack_public_path__ + "static/media/leaguesIcon.c36ff17328b10042e3572127fcb54ffa.svg";
export { ForwardRef as ReactComponent };